export default __webpack_public_path__ + "static/media/background3.0ed5c7ee.svg";